{
  "EMOJI": {
    "PLACEHOLDER": "Cari emoji",
    "NOT_FOUND": "Tidak ditemukan emoji yang sesuai dengan pencarian Anda",
    "REMOVE": "Hapus"
  }
}
